"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TableActionDelete_1 = __importDefault(require("../TableActionDelete"));
var TableActionCancel_1 = __importDefault(require("../TableActionCancel"));
var TableActionConfirm_1 = __importDefault(require("../TableActionConfirm"));
var contexts_1 = require("../../contexts");
var TableContext_1 = __importDefault(require("./TableContext"));
var ActionsColumn = function (_a) {
    var record = _a.record;
    var _b = react_1.useContext(TableContext_1.default), isEditing = _b.isEditing, currentEditing = _b.currentEditing, setEditing = _b.setEditing, handleDelete = _b.handleDelete;
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var handleSave = function () {
        if (formProps && formProps.dirty) {
            formProps.submitForm();
        }
    };
    var handleCancel = function () {
        if (formProps) {
            formProps.resetForm();
        }
        setEditing(undefined);
    };
    if (isEditing(record))
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TableActionConfirm_1.default, { onClick: handleSave }),
            react_1.default.createElement(TableActionCancel_1.default, { onClick: handleCancel })));
    if (handleDelete)
        return react_1.default.createElement(TableActionDelete_1.default, { disabled: currentEditing, onClick: handleDelete });
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = ActionsColumn;
